import React from "react";
import styled from "styled-components";

// inset은 함께 놓인 메뉴의 왼쪽 여백에 맞춘다(PC 사이드바 20px, 모바일 질문 내역 10px).
const LabsButton = ({ onClick, sidebar = false, inset = 20 }) => (
  <Button href="/lab" onClick={onClick} $sidebar={sidebar} $inset={inset} aria-label="랩스: 서비스 둘러보기">
    {sidebar && (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <circle cx="16" cy="16" r="16" fill="currentColor" opacity="0.07" />
        <path transform="translate(4 4) scale(.75)" d="M12 5h8m-6 0v8L7.5 23.5A2.3 2.3 0 0 0 9.5 27h13a2.3 2.3 0 0 0 2-3.5L18 13V5M11 19h10" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )}
    <span>랩스</span>
  </Button>
);

const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: ${({ $sidebar }) => ($sidebar ? "flex-start" : "center")};
  gap: 8px;
  box-sizing: border-box;
  width: ${({ $sidebar }) => ($sidebar ? "100%" : "auto")};
  height: ${({ $sidebar }) => ($sidebar ? "44px" : "38px")};
  flex-shrink: 0;
  padding: ${({ $sidebar, $inset }) => ($sidebar ? `0 ${$inset}px` : "0 6px")};
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.6);
  font-family: inherit;
  font-size: ${({ $sidebar }) => ($sidebar ? "16px" : "14px")};
  font-weight: 600;
  line-height: 26px;
  white-space: nowrap;
  text-decoration: none;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.85);
  }

  &:focus-visible {
    outline: 2px solid #00b965;
    outline-offset: 3px;
  }

  @media (max-width: 599px) {
    font-size: ${({ $sidebar }) => ($sidebar ? "16px" : "13px")};
  }
`;

export default LabsButton;
